import GraficoPrevisao from "./GraficoPrevisao";
import TabelaPrevisao from "../../Tabelas/TabelaPrevisao";

const TendenciaSazonalidade = ({ series, futureLabels, forecast, available }) => {
  if (!available) {
    return (
      <div className="p-message p-message-warn p-p-3">
        Este método exige pelo menos 24 meses de histórico.
      </div>
    );
  }

  return (
    <>
      <p>A previsão combina a tendência linear com o índice sazonal de cada mês.</p>
      <GraficoPrevisao
        series={series}
        futureLabels={futureLabels}
        methods={[{ key: "seasonal", method: forecast }]}
      />

      <TabelaPrevisao
        series={series}
        futureLabels={futureLabels}
        methods={[{ key: "seasonal", method: forecast }]}
      />
    </>
  );
};

export default TendenciaSazonalidade;
